import "../../index83.css";
import { jsx as n } from "react/jsx-runtime";
import { useCallback as a } from "react";
import { CloseLineIcon as f, QuestionLineIcon as _, InformationLineIcon as C, ErrorWarningLineIcon as h, CheckboxCircleLineIcon as w } from "@ifrc-go/icons";
import { _ as I } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import k from "../Button/index.js";
import y from "../Container/index.js";
import B from "../IconButton/index.js";
import b from "../../hooks/useTranslation.js";
const x = "common", L = {
  alertCopyErrorDetails: "Copy error details",
  closeButtonTitle: "Close"
}, N = {
  namespace: x,
  strings: L
}, T = "_alert_1r3or_1", v = "_icon_1r3or_6", D = "_info_1r3or_14", A = "_success_1r3or_18", E = "_danger_1r3or_22", M = "_warning_1r3or_26", o = {
  alert: T,
  icon: v,
  info: D,
  success: A,
  danger: E,
  warning: M
}, V = {
  success: o.success,
  warning: o.warning,
  danger: o.danger,
  info: o.info
}, W = {
  success: /* @__PURE__ */ n(w, { className: o.icon }),
  danger: /* @__PURE__ */ n(h, { className: o.icon }),
  info: /* @__PURE__ */ n(C, { className: o.icon }),
  warning: /* @__PURE__ */ n(_, { className: o.icon })
};
function J(c) {
  const {
    name: s,
    className: l,
    type: i = "info",
    title: m,
    description: u,
    onCloseButtonClick: t,
    nonDismissable: d,
    debugMessage: e
  } = c, r = b(N), g = a(
    () => {
      t && t(s);
    },
    [t, s]
  ), p = a(
    () => {
      e && navigator.clipboard.writeText(e);
    },
    [e]
  );
  return /* @__PURE__ */ n(
    y,
    {
      className: I(
        o.alert,
        V[i],
        l
      ),
      headerIcons: W[i],
      heading: m,
      headingLevel: 5,
      headerActions: !d && /* @__PURE__ */ n(
        B,
        {
          name: void 0,
          onClick: g,
          colorVariant: "text-on-dark",
          title: r.closeButtonTitle,
          ariaLabel: r.closeButtonTitle,
          children: /* @__PURE__ */ n(f, {})
        }
      ),
      withoutWrapInHeader: !0,
      withoutWrapInFooter: !0,
      footerActions: e && /* @__PURE__ */ n(
        k,
        {
          name: void 0,
          onClick: p,
          colorVariant: "text-on-dark",
          styleVariant: "translucent",
          textSize: "sm",
          spacing: "sm",
          children: r.alertCopyErrorDetails
        }
      ),
      withPadding: !0,
      withShadow: !0,
      children: u
    }
  );
}
export {
  J as default
};
